module.exports = __webpack_public_path__ + "static/media/Gilroy-Thin.390766b6.woff2";